import React, { useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
// import ModalConvocatoria from '../Modal/ModalConvocatoria';
import { useState } from 'react';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselImages } from '../../json/carouselImages';
// import Popup from 'reactjs-popup';
// import 'reactjs-popup/dist/index.css';


// const PopupExample = () => (
//   <Popup trigger={<button>Trigger</button>} position="top left">
//     {close => (
//       <div>
//         Content here
//         <a className="close" onClick={close}>
//           &times;
//         </a>
//       </div>
//     )}
//   </Popup>
// );


// const App = () => (
//   <div>
//     <PopupExample />
//     <div id="popup-root" />
//   </div>
// );
const Inicio = () => {
  // const [isModalOpen, setModalOpen] = useState (true);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  // const closeModal = () =>{
  //   setModalOpen (false); };

  return (
    <>
      <Carousel bannerData={carouselImages} serch={true} name={'corusel'} />
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Campo.svg")` }}>

            </div>
          </div>
          <div className='secretaria_name'>
            <h1>SECRETARÍA DE AGRICULTURA Y DESARROLLO RURAL</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La Secretaría de Agricultura y Desarrollo Rural del Estado de Hidalgo, es una Dependencia del Poder Ejecutivo que está enfocada en lograr el desarrollo económico y social de las familias que dependen de las actividades agropecuarias en el campo hidalguense, mediante la conformación y aplicación de programas y proyectos dirigidos a los productores</p>
            <div className='row'>
              <div className='col-md-4'>
                <h3 className='title-funciones'>Misión</h3>
                <p>La Secretaría de Agricultura y Desarrollo Rural es la dependencia de la Administración Pública del Estado de Hidalgo, que tiene por objeto planear e impulsar el desarrollo agropecuario, pesquero y rural, aprovechamiento de los recursos naturales y tecnológicos, con el fin de promover el desarrollo integral de las familias Hidalguenses.</p>
              </div>
              <div className='col-md-4'>
              <h3 className='title-funciones'>Visión</h3>
              <p>Lograr la máxima calidad en los productos del campo hidalguense, para satisfacer la creciente demanda de consumo en la entidad, así como consolidar el mercado tanto nacional como extranjero en materia agropecuaria, forestal, piscícola.</p>
              </div>
              <div className='col-md-4'>
              <h3 className='title-funciones'>Objetivo General</h3>
              <p>Proporcionar los servicios de organización, capacitación y apoyo a los productores de campo, orientando al incremento de productividad agropecuaria, pesquera y rural, que coadyuve al desarrollo de las organizaciones y comunidades rurales, así como el aprovechamiento de las oportunidades que los mercados nacionales e internacionales ofrecen para elevar el desarrollo humano y patrimonial de los Hidalguenses.</p>
              </div>
            </div>
              <div className='btn_organigrama'>
                <Link to={"https://sader.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/02.-Estructura"}  className="btn btn-primary button">Organigrama</Link>
                <Link to={"https://sader.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/01.-Normatividad"}  className="btn btn-primary button">Normatividad</Link>
                {/* <button type="button" className="btn btn-primary button">Normatividad</button> */}
              </div>
        
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/AgriculturaHgo' target='_blank'><i class="fa-brands fa-facebook-f"></i></a>
                <a href='https://twitter.com/AgriculturaHgo' target="_blank"><i class="fa-brands fa-twitter"></i></a>
              </div>
          </div>
        </div>
        {/* <UltimasNoticias/> */}
        <div className='row mt-5'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
            <hr className='hr-gob'/>
          </div>
          <div className='section_notes'>
            {
              titular.map((item, index) =>(
                  <>
                    <div key={ index } className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div>
                    </div>
                    <div className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Función del Secretario</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Conoce la agenda del Secretario</Link>
                        </div>
                      </div>
                    </div>
                  </>
              ))
            }
          </div>
        </div>
        {/* <ModalConvocatoria isOpen={isModalOpen} onClose={closeModal}/> */}

        <div className='row mt-5'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob'/>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3746.9986923003803!2d-98.77199028560769!3d20.092341524460622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a056d12ea317%3A0xe0885a972ecfebc2!2sSecretar%C3%ADa+de+Desarrollo+Agropecuario!5e0!3m2!1ses-419!2smx!4v1543275444535"
                    width="100%"
                    height="300"
                    frameborder="0"
                    style={{border:0, marginBottom:50}}
                    allowfullscreen>
            </iframe>
          </div>
        </div>

      </div>
    </>

  )
}

export default Inicio